import RichTextNPM from '@rotaryintl/component-rich-text';
import { RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
const RichTextComponent = ({ params: { ComponentId } = {}, fields: { RichText: RichTextField } = {} }) => (
  <RichTextNPM id={ComponentId}>
    <RichText field={RichTextField} />
  </RichTextNPM>
);
export default withSitecoreContext()(RichTextComponent);